import { TenantConfig } from "../tenant.model";

export const tenant: TenantConfig = {
    tenandId: 'asl-salerno',
    brandName: 'ASL Salerno',
    brandLogoImage: null,
    favicon: 'default-favicon.ico',
    showSupplierLogo: false,
    apiUrl: 'https://api.aslsalerno.test.assistant.beta80group.it',
    apiUrlProd: 'https://api.aslsalerno.assistant.beta80group.it',
    navigationItems: [
        { label: 'Home', route: '/overview', group: 'settings' },
        { label: 'Statistiche', route: '/statistiche', group: 'navigation', featureName: 'statistics' },
        { label: 'Documenti', route: '/documenti', group: 'navigation', featureName: 'document' },
        { label: 'Links', route: '/ingestion-link', group: 'navigation', featureName: 'ingestion-link' },
        { label: 'Conversazioni', route: '/conversazioni', group: 'navigation', featureName: 'conversations' },
        { label: 'Valutazioni', route: '/valutazioni', group: 'navigation', featureName: 'feedback' },
        { label: 'Ricerca Chunks', route: '/chunks', group: 'navigation', featureName: 'chunk' },
        { label: 'Permessi', route: '/permessi', group: 'navigation', featureName: 'permissions', requiresAdmin: true },
        { label: 'Impostazioni', route: '/impostazioni', group: 'navigation', featureName: 'settings', requiresAdmin: true },
    ],
    apiEndpoints: {
        document: '/document',
        assistant: '/assistant',
    },
    documentiApi: '/document',
    samlProviderName: 'assistant-external-idp',
    samlProviderNameProd: 'assistant-external-idp',
    samlEnabled: false,
    chatConfig: {
        // TRUE = Scarica da CloudFront oppure FALSE = Usa il file asl-salerno-chat.bundle.js presente nella cartella del componente
        useRemoteLoader: true,
        remoteTestUrl: 'https://d3so8u9uewocbp.cloudfront.net/bundle/asl-salerno-chat.bundle.js',
        remoteProdUrl: 'https://d11zdqjy12f21w.cloudfront.net/bundle/asl-salerno-chat.bundle.js',
        bundleFile: 'asl-salerno-chat.bundle.js',
        elementTag: 'asl-salerno-chat',
        assistantName: 'NEXA',
        envConfig: {
            uat: { apiEndpoint: 'https://api.aslsalerno.test.assistant.beta80group.it' },
            prod: { apiEndpoint: 'https://api.aslsalerno.assistant.beta80group.it' },
        },
    },
    amplifyConfig: {
        // NOTE: placeholder Cognito values — replace with the ASL Salerno pool/client ids once provisioned.
        nativeAuth: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_pJ3eIhzMd',
            userPoolWebClientId: '5h9ucovaobd9tvcf6mrvmue1r5',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {
                domain: 'eu-central-1qlodffouz.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'https://www.aslsalerno.test.assistant.beta80group.it/login',
                redirectSignOut: 'https://www.aslsalerno.test.assistant.beta80group.it/login',
                responseType: 'code',
            },
        },
        nativeAuthProd: {
            region: 'eu-central-1',
            userPoolId: '',
            userPoolWebClientId: '5a0ek36m89je9q55racv22b54c',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {
                domain: 'eu-central-1mpoibwzsd.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'https://aslsalerno.assistant.beta80group.it/',
                redirectSignOut: 'https://aslsalerno.assistant.beta80group.it/',
                responseType: 'code',
            },
        },
    },
    theme: {
        semantic: {
            primary: {
                50: '#e8f1fb',
                100: '#c5dcf5',
                200: '#9ec5ee',
                300: '#6fa8e3',
                400: '#3d84cf',
                500: '#0B5CA8',
                600: '#094c8c',
                700: '#073a6b',
                800: '#05294c',
                900: '#03182d',
                950: '#020f1c',
            },
            danger: {
                50: '#fef2f2',
                100: '#fee2e2',
                200: '#fecaca',
                300: '#fca5a5',
                400: '#f87171',
                500: '#dc2626',
                600: '#b91c1c',
                700: '#991b1b',
                800: '#7f1d1d',
                900: '#601414',
                950: '#400a0a',
            },
            secondary: {
                50: '#f5f5f5',
                100: '#e5e5e5',
                200: '#cccccc',
                300: '#b3b3b3',
                400: '#999999',
                500: '#555555',
                600: '#444444',
                700: '#333333',
                800: '#222222',
                900: '#111111',
                950: '#0a0a0a',
            },
            formField: {
                borderRadius: '4px',
                paddingX: '12px',
                paddingY: '12px',
                borderWidth: '2px',
            },
        },
        form: {
            iconColor: '#0B5CA8',
        },
        components: {
            datatable: {
                headerCell: {
                    background: '#e8f1fb'
                }
            },
            card: {
                body: {
                    padding: '0',
                }
            },
            dialog: {
                header: {
                    padding: '32px 32px 0 32px',
                },
                content: {
                    padding: '32px',
                },
                footer: {
                    padding: '0 32px 32px 32px',
                }
            },
        }
    },
};
